<!--
  Mobile layout for this page. The split into Raw Materials / Products (spec §1)
  applies to both layouts — this is the same screen, just rendered for phones —
  so the mobile view is pinned to this page's domain instead of following the
  old shared raw/products tab.
-->
<app-mobile-inventory-view
  class="d-md-none"
  lockedTab="raw"
  [totalRawMaterials]="totalRawMaterials"
  [lowStockItems]="lowStockItems"
  [totalRawMaterialValue]="totalRawMaterialValue"
  [rawMaterials]="rawMaterials"
  [categories]="categories"
  [unitsOfMeasure]="uomList"
  [suppliers]="suppliers"
  [stackedBarData]="stackedBarData"
  [baseColors]="baseColors"
  [categoryLabels]="categoryLabels"
  [categoryData]="categoryData"
  (saveItemMobile)="saveItemMobile($event)"
  (deleteItemMobile)="deleteItemMobile($event)"
  (downloadTemplateMobile)="downloadTemplate()"
  (importMobile)="onFileSelected($event)"
  (createCategoryMobile)="createCategoryMobile($event)"
></app-mobile-inventory-view>

<div class="container-fluid">
  <div class="welcome-section mb-4 fade-in d-none d-md-block">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="fw-bold">Raw Materials</h2>
        <h4 class="welcome-text">Check your raw material stock levels and manage them</h4>
      </div>
      <div class="text-end">
        <small class="text-muted d-block">Current User:</small>
        <h6 class="mb-0">{{fullName}}</h6>
        <small class="text-muted d-block">{{tenantName}}</small>
      </div>
    </div>
  </div>

  <div class="dashboard-cards fade-in d-none d-md-flex">
    <div class="metric-card main" style="width: 50%;">
      <div class="card-content">
        <div class="icon-container main">
          <i class="bi bi-hammer" style="font-size: 1.5rem; color: #007A8F;"></i>
        </div>
        <div class="metric-info">
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center gap-2 mb-2">
              <p class="metric-label">Total Raw Materials</p>
            </div>
            <span class="fw-bold text-center" style="font-size: 1.4rem;">{{ totalRawMaterials }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="metric-card warning" style="width: 45%;" [class.pulse]="lowStockItems > 0 && showLowStockPopup">
      <div class="card-content">
        <div class="icon-container warning">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 16H12.01M12 8V12M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke="#6C7A3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div class="metric-info">
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center gap-2 mb-2">
              <p class="metric-label">Low Raw Material Items</p>
            </div>
            <span class="fw-bold text-center" style="font-size: 1.4rem;">{{ lowStockItems }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="metric-card success">
      <div class="card-content">
        <div class="icon-container success">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15V17M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke="#B0213C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 10C9.5 8.61929 10.6193 7.5 12 7.5C13.3807 7.5 14.5 8.61929 14.5 10C14.5 11.3807 13.3807 12.5 12 12.5C10.6193 12.5 9.5 11.3807 9.5 10Z"
              stroke="#B0213C" stroke-width="2" />
          </svg>
        </div>
        <div class="metric-info">
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center gap-2 mb-2">
              <p class="metric-label">Total Raw Material Value</p>
            </div>
            <span class="fw-bold text-center" style="font-size: 1.4rem;">
              {{ totalRawMaterialValue | currency:'ZAR':'symbol':'1.2-2' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dashboard-cards fade-in">
    <div class="metric-card inv-raw-section" style="flex-grow: 1; max-height: 120vh; display: flex; flex-direction: column">
      <div class="card-body" style="display: flex; flex-direction: column; flex: 1; min-height: 0">
        <div class="CardHeader">
          <div class="d-flex align-items-center">
            <div class="chart-icon-container me-3">
              <i class="bi bi-box-seam"></i>
            </div>
            <span style="display: flex; align-items: center;">
              <h3 style="margin-bottom: 5px;">Raw Materials</h3>
              <app-tooltip [tooltipId]="'IngredientsMaterial'">
                <i icon class="bi bi-info-circle"></i>
                <div content>
                  <p>
                    <strong>
                      Think of raw materials as the items you need to make something.
                      <br><br>
                      NB:
                      <br>
                      Remember to update unit cost if the suppliers changed their pricing.
                    </strong>
                  </p>
                </div>
              </app-tooltip>
            </span>
          </div>
          <div role="group" aria-label="Raw Material Actions" style="display: flex; align-items: center; gap: 4px;">
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text" (click)="downloadTemplate()" [disabled]="isImporting">
              <i class="bi bi-download"></i>
              Download Template
            </button>

            <button *ngIf="zeroReorderItems.length > 0" type="button"
              class="btn btn-warning btn-sm text" (click)="showReorderPrompt = true">
              <i class="bi bi-exclamation-triangle"></i>
              Set Reorder Levels ({{ zeroReorderItems.length }})
            </button>

            <input #fileInput type="file" accept=".xlsx" (change)="onFileSelected($event)" hidden>

            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text d-flex align-items-center gap-1" (click)="fileInput.click()"
              [disabled]="isImporting">
              <i class="bi bi-upload"></i>
              Import
            </button>

            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text d-flex align-items-center gap-1" (click)="openAddOption()">
              <i class="bi bi-plus"></i>
              Add
            </button>
          </div>
        </div>

        <div class="inv-toolbar d-flex align-items-center gap-2 mb-3 flex-wrap" style="padding-top: 5px;">
          <div class="input-group" style="max-width: 75%; flex: 1 1 220px;">
            <span class="input-group-text"><i class="bi bi-search"></i></span>
            <input type="text" class="form-control" placeholder="Search Raw Materials..."
              [(ngModel)]="rawMaterialsSearchTerm" (input)="filterRawMaterials()" />
          </div>

          <div class="btn-group segmented" role="group" aria-label="Raw material type filter">
            <input type="radio" class="btn-check" name="rawType" id="raw-type-all" autocomplete="off"
                   [checked]="rawTypeFilter === 'all'"
                   (change)="rawTypeFilter = 'all'; filterRawMaterials()">
            <label class="btn segmented-btn"
                   [class.btn-teal-gradient]="rawTypeFilter === 'all'"
                   [class.btn-grey-gradient]="rawTypeFilter !== 'all'"
                   for="raw-type-all">
              <i class="bi bi-collection me-1"></i> All
            </label>

            <input type="radio" class="btn-check" name="rawType" id="raw-type-standard" autocomplete="off"
                   [checked]="rawTypeFilter === 'standard'"
                   (change)="rawTypeFilter = 'standard'; filterRawMaterials()">
            <label class="btn segmented-btn"
                   [class.btn-teal-gradient]="rawTypeFilter === 'standard'"
                   [class.btn-grey-gradient]="rawTypeFilter !== 'standard'"
                   for="raw-type-standard">
              <i class="bi bi-box-seam me-1"></i> Standard
            </label>

            <input type="radio" class="btn-check" name="rawType" id="raw-type-buyout" autocomplete="off"
                   [checked]="rawTypeFilter === 'buyout'"
                   (change)="rawTypeFilter = 'buyout'; filterRawMaterials()">
            <label class="btn segmented-btn"
                   [class.btn-teal-gradient]="rawTypeFilter === 'buyout'"
                   [class.btn-grey-gradient]="rawTypeFilter !== 'buyout'"
                   for="raw-type-buyout">
              <i class="bi bi-cart-check me-1"></i> Buy Out
            </label>
          </div>

          <div class="filter-button-container">
            <button class="btn btn-teal-gradient btn-sm" [class.btn-teal-gradient]="!isFilterPanelOpenRawMaterials"
              [class.btn-grey-gradient]="isFilterPanelOpenRawMaterials" type="button"
              (click)="toggleFilterPanelRawMaterials()">
              <i class="bi bi-funnel"></i>
              {{ !isFilterPanelOpenRawMaterials ? 'Show Filters' : 'Hide Filters' }}
            </button>
          </div>
        </div>

        <div class="filter-panel-container">
          <div class="filter-panel" [class.visible]="isFilterPanelOpenRawMaterials">
            <div class="d-flex align-items-center">
              <select class="form-select form-select-sm" [(ngModel)]="selectedCategoryFilter"
                (change)="filterRawMaterials()">
                <option [ngValue]="null">All Categories</option>
                <option *ngFor="let category of categories" [ngValue]="category.categoryId">
                  {{ category.categoryName }}
                </option>
              </select>
            </div>

            <div class="d-flex align-items-center">
              <select class="form-select form-select-sm" [(ngModel)]="selectedUOMFilter"
                (change)="filterRawMaterials();">
                <option [ngValue]="null">All Units of Measure</option>
                <option *ngFor="let uom of uomList" [ngValue]="uom.uomid">
                  {{ uom.uomName }}
                </option>
              </select>
            </div>

            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center gap-2 w-100">
                <span class="text-muted me-2">Stock</span>
                <div class="btn-group segmented" role="group" aria-label="Stock filter">
                  <input type="radio" class="btn-check" name="rmStock" id="rm-stock-all" autocomplete="off"
                         [checked]="!showLowStockOnly && !showNonLowStockOnly"
                         (change)="showLowStockOnly=false; showNonLowStockOnly=false; filterRawMaterials()">
                  <label class="btn segmented-btn"
                         [class.btn-teal-gradient]="!showLowStockOnly && !showNonLowStockOnly"
                         [class.btn-grey-gradient]="showLowStockOnly || showNonLowStockOnly"
                         for="rm-stock-all">
                    <i class="bi bi-collection me-1"></i> All
                  </label>

                  <input type="radio" class="btn-check" name="rmStock" id="rm-stock-low" autocomplete="off"
                         [checked]="showLowStockOnly && !showNonLowStockOnly"
                         (change)="showLowStockOnly=true; showNonLowStockOnly=false; filterRawMaterials()">
                  <label class="btn segmented-btn"
                          [class.btn-teal-gradient]="showLowStockOnly && !showNonLowStockOnly"
                          [class.btn-grey-gradient]="!showLowStockOnly || showNonLowStockOnly"
                          for="rm-stock-low">
                    <i class="bi bi-exclamation-triangle me-1"></i> Low
                  </label>

                  <input type="radio" class="btn-check" name="rmStock" id="rm-stock-in" autocomplete="off"
                         [checked]="!showLowStockOnly && showNonLowStockOnly"
                         (change)="showLowStockOnly=false; showNonLowStockOnly=true; filterRawMaterials()">
                  <label class="btn segmented-btn"
                          [class.btn-teal-gradient]="!showLowStockOnly && showNonLowStockOnly"
                          [class.btn-grey-gradient]="showLowStockOnly || !showNonLowStockOnly"
                          for="rm-stock-in">
                    <i class="bi bi-check-circle me-1"></i> In stock
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center mt-2">
              <div class="d-flex align-items-center gap-2 w-100 justify-content-end">
                <span class="text-muted me-1">Rows per page</span>
                <select class="form-select form-select-sm" style="max-width: 90px"
                        [(ngModel)]="rawMaterialsPageSize"
                        (ngModelChange)="rawMaterialsCurrentPage = 1">
                  <option [ngValue]="15">15</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="table-responsive scrollable-content" style="flex-grow: 1; min-height: 0; overflow-y: auto">
          <div *ngIf="rawMaterials.length === 0" class="empty-state p-4 text-center">
            <div class="empty-state-icon mb-3">
              <i class="bi bi-box-seam" style="font-size: 2.5rem; color: #6c757d;"></i>
            </div>
            <h5 class="mb-2">No Raw Materials</h5>
            <p class="text-muted mb-0">Add your first Raw Material to get started</p>
            <button class="btn btn-primary mt-3" (click)="openAddOption()">
              <i class="bi bi-plus-circle me-1"></i> Add Raw Material
            </button>
          </div>

          <table class="table table-hover align-middle mb-0 d-none d-md-table" *ngIf="rawMaterials.length > 0">
            <thead class="table-header rounded-2">
              <tr>
                <th class="fw-bold" style="cursor: pointer" (click)="sortBy('itemCode')">
                  SKU
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill': sortColumn !== 'itemCode' || (sortColumn === 'itemCode' && sortDirection === 'desc'),
                        'bi-caret-up-fill': sortColumn === 'itemCode' && sortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortBy('itemName')">
                  Item Name
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill': sortColumn !== 'itemName' || (sortColumn === 'itemName' && sortDirection === 'desc'),
                        'bi-caret-up-fill': sortColumn === 'itemName' && sortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortBy('purchaseUOMID')">
                  UOM
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill': sortColumn !== 'purchaseUOMID' || (sortColumn === 'purchaseUOMID' && sortDirection === 'desc'),
                        'bi-caret-up-fill': sortColumn === 'purchaseUOMID' && sortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: pointer; min-width: 125px; width: 125px;" class="fw-bold" (click)="sortBy('CategoryName')">
                  Category
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill': sortColumn !== 'CategoryName' || (sortColumn === 'CategoryName' && sortDirection === 'desc'),
                        'bi-caret-up-fill': sortColumn === 'CategoryName' && sortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: default" class="fw-bold">Quantity</th>
                <th style="cursor: default" class="fw-bold">Reorder At</th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortBy('unitCost')">
                  Unit Cost
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill': sortColumn !== 'unitCost' || (sortColumn === 'unitCost' && sortDirection === 'desc'),
                        'bi-caret-up-fill': sortColumn === 'unitCost' && sortDirection === 'asc'
                      }"></i>
                </th>
                <th *ngIf="userRole === 'Admin User'" style="cursor: default" class="fw-bold text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of rawMaterialsPaged">
                <td>{{ item.itemCode }}</td>
                <td class="fw-semibold">
                  {{ item.itemName }}
                  <!-- Spec §4: Buy Out items are raw materials that are resold as-is. -->
                  <span class="type-badge type-badge--buyout" *ngIf="item.isBuyout">Buy Out</span>
                </td>
                <td>{{ getUOMName(item.purchaseUOMID) }}</td>
                <td>
                  <span class="category-badge" [style.background-color]="getCategoryColor(item.CategoryName)">
                    {{ item.CategoryName }}
                  </span>
                </td>
                <td>
                  <span class="quantity-badge" [ngClass]="{
                    'badge-warning': (item.quantity ?? 0) === (item.lowStockThreshold ?? 0),
                        'badge-success': (item.quantity ?? 0) > (item.lowStockThreshold ?? 0),
                        'badge-danger': (item.quantity ?? 0) < (item.lowStockThreshold ?? 0)
                      }">
                    {{ item.quantity | number: '1.2-2' }}
                  </span>
                </td>
                <td>
                  <span class="quantity-badge badge-neutral">{{ item.lowStockThreshold }}</span>
                </td>
                <td>{{ item.purchasePrice / item.purchaseQuantity | currency : "ZAR" : 'symbol' : '1.2-2' }}</td>
                <td *ngIf="userRole === 'Admin User'" class="text-nowrap">
                  <button *ngIf="userRole === 'Admin User'" class="btn-outline-primary" (click)="editItem(item)">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button *ngIf="userRole === 'Admin User'" class="btn-outline-primary danger"
                    (click)="selectedItem = item; showDeleteModal = true">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <nav *ngIf="rawMaterialsTotalPages > 1" class="mt-2" aria-label="Raw materials pagination">
          <ul class="pagination pagination-sm mb-0 justify-content-end">
            <li class="page-item" [class.disabled]="rawMaterialsCurrentPage === 1">
              <button class="page-link" type="button" (click)="changeRawMaterialsPage(rawMaterialsCurrentPage - 1)" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </button>
            </li>
            <li class="page-item" *ngFor="let page of rawMaterialsPages" [class.active]="page === rawMaterialsCurrentPage">
              <button class="page-link" type="button" (click)="changeRawMaterialsPage(page)">{{ page }}</button>
            </li>
            <li class="page-item" [class.disabled]="rawMaterialsCurrentPage === rawMaterialsTotalPages">
              <button class="page-link" type="button" (click)="changeRawMaterialsPage(rawMaterialsCurrentPage + 1)" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <div class="dashboard-cards fade-in d-none d-md-flex">
    <div class="chart-container metric-card chart-40" style="min-height: 80vh;height: calc(100% - 40px);">
      <app-pie-chart *ngIf="categoryLabels.length > 0 && categoryData.length > 0" [labels]="categoryLabels"
        [data]="categoryData" [title]="'Raw Material Stock Distribution by Category'" [colors]="baseColors" [ItemsPerPage]="5">
      </app-pie-chart>
      <div *ngIf="categoryLabels.length === 0 || categoryData.length === 0"
        class="d-flex align-items-center justify-content-center h-100">
        <div class="text-center p-4">
          <i class="bi bi-pie-chart fs-1 text-muted mb-2"></i>
          <p class="mb-0">No data available for the pie chart</p>
          <small class="text-muted">Add raw materials with categories to see the distribution</small>
        </div>
      </div>
    </div>

    <div class="metric-card chart-60">
      <div class="chart-container" style="height: calc(100% - 40px);">
        <div *ngIf="stackedBarData && stackedBarData.labels && stackedBarData.labels.length > 0; else noBarData" class="h-100">
          <app-reuseable-bar-chart
            [title]="'Raw Material Stock Value by Category'"
            [labels]="stackedBarData.labels"
            [data]="stackedBarData.datasets[0].data"
            [colors]="baseColors"
            [ItemsPerPage]="ItemsPerPage"
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [totalItemsCount]="totalItemsCount"
            [goToPage]="goToPage"
            [pageSizeChange]="onPageSizeChange"
            (pageChange)="onPageChange($event)">
          </app-reuseable-bar-chart>
        </div>

        <ng-template #noBarData>
          <div class="d-flex align-items-center justify-content-center h-100">
            <div class="text-center p-4">
              <i class="bi bi-bar-chart fs-1 text-muted mb-2"></i>
              <p class="mb-0">No data available for the bar chart</p>
              <small class="text-muted">Add raw materials with categories to see the distribution</small>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="d-none d-md-block">
  <app-alert
    [visible]="isAlertVisible"
    [title]="alertTitle"
    [message]="alertMessage"
    [alertbgcolor]="alertBgColor"
    [alerttextcolor]="alerttextcolor"
    (closed)="isAlertVisible = false">
  </app-alert>
</div>

<app-inventory-item-modal
  [visible]="showAddModal"
  [isEditing]="isEditing"
  [isFinishedGood]="false"
  [isServiceItem]="false"
  [isAddingQuantity]="isAddingQuantity"
  [showPurchaseFields]="showPurchaseFields"
  [inventoryForm]="inventoryForm"
  [supplierForm]="supplierForm"
  [categoryForm]="categoryForm"
  [isCreatingSupplier]="isCreatingSupplier"
  (isCreatingSupplierChange)="isCreatingSupplier = $event"
  [isCreatingCategory]="isCreatingCategory"
  (isCreatingCategoryChange)="isCreatingCategory = $event"
  [selectedSupplier]="selectedSupplier"
  [selectedCategory]="selectedCategory"
  [supplierOptions]="desktopSupplierOptions"
  [categoryOptions]="desktopCategoryOptions"
  [uomList]="uomList"
  (save)="saveItem()"
  (cancel)="closeAddModal()"
  (quickClose)="showAddModal = false; inventoryForm.reset(); supplierForm.reset(); categoryForm.reset();"
  (createSupplierClick)="createSupplier()"
  (createCategoryClick)="createCategory()"
  (navigateToAddSupplierClick)="navigateToAddSupplier()"
  (togglePurchaseFieldsClick)="togglePurchaseFields()"
  (supplierSelected)="onDesktopSupplierSelected($event)"
  (categorySelected)="onDesktopCategorySelected($event)"
  (quantityToAddChange)="setQuantityToAdd($event)">
</app-inventory-item-modal>

<div *ngIf="showAddModal && isAddingQuantity" class="modal-backdrop" (click)="closeAddModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Add Quantity</h2>
      <button type="button" class="close-button" (click)="closeAddModal()">×</button>
    </div>
    <form [formGroup]="inventoryForm">
      <div class="modal-body">
        <div class="mb-4">
          <div class="form-group">
            <label class="form-label">Item Name</label>
            <div class="form-control-plaintext">{{inventoryForm.get('itemName')?.value}}</div>
          </div>
          <div class="form-group">
            <label class="form-label">Current Quantity</label>
            <div class="form-control-plaintext">{{inventoryForm.get('currentQuantity')?.value || 0}}</div>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Quantity to Add</label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0">
              <i class="bi bi-plus-circle text-secondary"></i>
            </span>
            <input type="number" class="form-control border-start-0" formControlName="quantityToAdd" min="1" step="1" required />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="addQuantityToItem()">Add Quantity</button>
      </div>
    </form>
  </div>
</div>

<div class="modal fade" id="importProgressModalRaw" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
  [class.show]="isImporting" [style.display]="isImporting ? 'block' : 'none'" [attr.aria-hidden]="!isImporting">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title d-flex align-items-center">
          <i class="bi bi-upload me-2"></i>
          Importing Items
        </h5>
      </div>
      <div class="modal-body p-4">
        <div class="d-flex justify-content-center mb-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <h6 class="text-center mb-3">Processing your import...</h6>
        <div class="progress mb-4" style="height: 10px; border-radius: 5px;">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
            [style.width]="importProgress + '%'" [attr.aria-valuenow]="importProgress" aria-valuemin="0" aria-valuemax="100">
            <span class="visually-hidden">{{ importProgress }}% Complete</span>
          </div>
        </div>
        <div class="d-flex justify-content-between mb-2">
          <small class="text-muted">Progress</small>
          <small class="fw-bold">{{ importProgress }}%</small>
        </div>
        <div class="text-center mt-4">
          <p class="small text-muted mb-0">
            <i class="bi bi-info-circle me-1"></i>
            Please do not close this window while the import is in progress.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="errorDetailsModalRaw" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content border-0 shadow">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title d-flex align-items-center">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          Import Results
        </h5>
        <button type="button" class="close-button" data-bs-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body p-4">
        <div *ngIf="importResults.errors.length > 0" class="mt-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">
              <i class="bi bi-exclamation-triangle text-warning me-2"></i>
              Import Issues ({{ importResults.errors.length }})
            </h6>
            <span>
              <span *ngIf="errorCount() > 0" class="badge bg-danger me-1">{{ errorCount() }} error{{ errorCount() !== 1 ? 's' : '' }}</span>
              <span *ngIf="warningCount() > 0" class="badge bg-warning text-dark">{{ warningCount() }} need{{ warningCount() === 1 ? 's' : '' }} review</span>
            </span>
          </div>
          <div class="table-responsive">
            <table class="table table-sm table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th style="width: 5rem;">Row</th>
                  <th class="w-25">Item</th>
                  <th style="width: 8rem;">Value</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let error of importResults.errors; let i = index" [attr.data-testid]="'error-row-' + i"
                  class="border-start border-4"
                  [class.border-danger]="error.severity !== 'warning'"
                  [class.border-warning]="error.severity === 'warning'">
                  <td class="text-muted">{{ error.rowNumber || error.rowIndex }}</td>
                  <td class="fw-semibold">
                    <div class="d-flex align-items-center">
                      <i class="bi me-2"
                        [class.bi-x-circle-fill]="error.severity !== 'warning'"
                        [class.text-danger]="error.severity !== 'warning'"
                        [class.bi-exclamation-triangle-fill]="error.severity === 'warning'"
                        [class.text-warning]="error.severity === 'warning'"></i>
                      {{ error.item['itemname*'] || error.itemName || 'Unknown Item' }}
                    </div>
                  </td>
                  <td>
                    <code *ngIf="error.rawValue">{{ error.rawValue }}</code>
                  </td>
                  <td>
                    <span class="badge bg-opacity-10"
                      [class.bg-danger]="error.severity !== 'warning'"
                      [class.bg-warning]="error.severity === 'warning'"
                      [style.color]="error.severity === 'warning' ? '#000' : '#fff'">
                      {{ error.error }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button *ngIf="hasRawMaterialErrors()" type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="downloadFailedRawMaterials()">
          <i class="bi bi-download"></i> Download Failed Raw Materials
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showAddOptionModal" class="modal-backdrop" (click)="showAddOptionModal = false">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header p-3">
      <h2>Add Ingredients / Materials</h2>
      <button type="button" class="close-button" (click)="showAddOptionModal = false">×</button>
    </div>
    <div class="button-group p-3 d-flex justify-content-center">
      <button class="btn btn-primary me-2" (click)="selectAddOption('new')">Add New Item</button>
      <button class="btn btn-primary" (click)="selectAddOption('existing')">Add Quantity to Existing Item</button>
    </div>
  </div>
</div>

<div *ngIf="showItemSelectModal" class="modal-backdrop" (click)="closeItemSelectModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Select Item</h2>
      <button type="button" class="close-button" (click)="closeItemSelectModal()">x</button>
    </div>
    <div class="search-bar p-3 d-flex justify-content-center">
      <div class="input-group" style="min-width: 30%">
        <span class="input-group-text"><i class="bi bi-search"></i></span>
        <input type="text" class="form-control" placeholder="Search Items..." [(ngModel)]="rawMaterialsSearchTerm"
          (input)="filterRawMaterials()" />
      </div>
    </div>
    <div class="p-3 items-list">
      <div *ngFor="let item of rawMaterials" class="item-card" (click)="selectItemForQuantityAdd(item)">
        <div class="item-info">
          <div class="item-name">{{ item.itemName }}</div>
          <div class="item-details">
            <span>SKU: {{ item.itemCode }}</span>
            <span>Current Quantity: {{ item.quantity }}</span>
          </div>
        </div>
      </div>
      <button class="btn btn-secondary" (click)="closeItemSelectModal()">Cancel</button>
    </div>
  </div>
</div>

<div *ngIf="lowStockItems !== 0 && showLowStockPopup" class="modal-backdrop inv-low-stock-desktop">
  <div class="modal-content">
    <div class="modal-header">
      <h4>Low Stock Items</h4>
      <button type="button" class="close-button" (click)="closeLowStockPopup()">x</button>
    </div>
    <div class="modal-body">
      <h4>The following items are low in stock:</h4>
      <div style="margin-bottom: 10px; border: 1px solid #dee2e6; padding: 10px; border-radius: 5px; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);"
        *ngFor="let item of lowStockItemsList">
        <h5 style="margin-bottom: 5px; background-color: #107C8F; padding: 5px; border-radius: 5px;color: white;">
          {{item.name}}</h5>
        <h5 style="margin-bottom: 5px;">Has <span style="color: red;">{{item.quantity}}</span> remaining (Reorder at: {{ item.threshold }})</h5>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="closeLowStockPopup()">Close</button>
    </div>
  </div>
</div>

<div *ngIf="lowStockItems !== 0 && showLowStockPopup" class="inv-offcanvas-backdrop d-md-none" (click)="closeLowStockPopup()">
  <div class="inv-offcanvas-sheet" (click)="$event.stopPropagation()">
    <div class="inv-sheet-handle-bar">
      <div class="inv-sheet-handle"></div>
    </div>
    <div class="inv-sheet-header">
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-exclamation-triangle-fill text-warning fs-5"></i>
        <span class="inv-sheet-title">Low Stock Items</span>
      </div>
      <button class="inv-sheet-close" (click)="closeLowStockPopup()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="inv-sheet-body">
      <p class="text-muted small mb-3">The following items are running low and need restocking:</p>
      <div class="inv-low-stock-card" *ngFor="let item of lowStockItemsList">
        <div class="inv-low-stock-name">{{ item.name }}</div>
        <div class="inv-low-stock-detail">
          <span class="inv-low-stock-qty">{{ item.quantity }} remaining</span>
          <span class="inv-low-stock-threshold">Reorder at: {{ item.threshold }}</span>
        </div>
      </div>
      <button class="inv-sheet-close-btn mt-3" (click)="closeLowStockPopup()">Dismiss</button>
    </div>
  </div>
</div>

<div *ngIf="showReorderPrompt" class="modal-backdrop" (click)="closeReorderPrompt()">
  <div class="modal-content" (click)="$event.stopPropagation()" style="max-width: 500px;">
    <div class="modal-header">
      <h4>Set Reorder Levels</h4>
      <button type="button" class="close-button" (click)="closeReorderPrompt()">x</button>
    </div>
    <div class="modal-body">
      <p class="text-muted mb-3">The following items have no reorder level set. Setting a reorder level helps you get notified when stock runs low.</p>
      <div *ngFor="let item of zeroReorderItems"
        style="margin-bottom: 10px; border: 1px solid #dee2e6; padding: 10px; border-radius: 5px;">
        <div class="d-flex justify-content-between align-items-center">
          <span class="fw-semibold">{{ item.itemName }}</span>
          <div class="input-group" style="max-width: 200px;">
            <input type="number" class="form-control form-control-sm"
              [(ngModel)]="reorderEditValues[item.itemID]" min="0" placeholder="Reorder at" />
            <span class="input-group-text input-group-text-sm">{{ getUOMName(item.purchaseUOMID) || 'units' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeReorderPrompt()">Skip for Now</button>
      <button class="btn btn-primary" (click)="saveReorderLevels()">Save Reorder Levels</button>
    </div>
  </div>
</div>

<div *ngIf="showDeleteModal && selectedItem" class="modal-backdrop" (click)="showDeleteModal = false">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Delete Ingredients / Materials</h2>
      <button type="button" class="close-button" (click)="showDeleteModal = false">x</button>
    </div>
    <div class="modal-body">
      <p>Are you sure you want to delete this ingredient / material?</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="showDeleteModal = false">Cancel</button>
      <button class="btn btn-danger" (click)="selectedItem && deleteItem(selectedItem)">Delete</button>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="app-spinner-overlay">
  <div class="app-loading-spinner"></div>
</div>
